<app-menu-crud-panel-bot [btns]="btnsL" [rows]="recordRowsLogs" [conf]="recordConfBtns" [toggle]="layoutAsToggle">
	<div PanelContent>
		<div class="w-full h-full">
			<textarea placeholder="Notes" class="crud-input-textarea" [(ngModel)]="svcMenuCrudMind.note"></textarea>
		</div>
	</div>
</app-menu-crud-panel-bot>